'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Front = _interopRequireDefault(require("Layouts/Front"));
var _FrontCandidateForm = _interopRequireDefault(require("Components/Forms/Models/Candidate/FrontCandidateForm"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
class CandidateUpdateRecordPage extends _react.Component {
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    return /*#__PURE__*/_react.default.createElement(_Front.default, _extends({
      page_title: "Mon dossier | AspieJob"
    }, props), /*#__PURE__*/_react.default.createElement("div", {
      className: "o-back-content o-content--registration-form"
    }, /*#__PURE__*/_react.default.createElement(_FrontCandidateForm.default, {
      type: "update"
    })));
  }
}
exports.default = CandidateUpdateRecordPage;
